/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package tables.domain.model

enum class DayNumber(val number: Long) {
    N1(number = 1),
    N2(number = 2),
    N3(number = 3),
    N4(number = 4),
    N5(number = 5),
    N6(number = 6),
    N7(number = 7)
}